import { combineReducers } from "redux";

import authenticationReducer from "./authentication";
import shiftsReducer from "./shifts";
import ordersReducer from "./orders";
import reservationsReducer from "./reservations";
import customersReducer from "./customers";
import tablesReducer from "./tables";
import marketingReducer from "./marketing";
import settingsReducer from "./settings";
import uiReducer from "./ui";
import autoRefreshReducer from "./autoRefresh";
import zoneReducer from "./zones";
import artefactsReducer from "./artefacts";
import feedbacksReducer from "./feedbacks";


export default combineReducers({
    authenticationReducer,
    shiftsReducer,
    ordersReducer,
    reservationsReducer,
    customersReducer,
    tablesReducer,
    marketingReducer,
    settingsReducer,
    uiReducer,
    autoRefreshReducer,
    zoneReducer,
    artefactsReducer,
    feedbacksReducer,
});


// WEBPACK FOOTER //
// ./src/store/reducers/index.js